import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import InfoTracking from '@app/components/common/InfoTracking';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space} from 'antd';
import {getAll, drop} from '../../../../apis/PeriodosApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catalogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <ClockCircleFilled />
        <span>Periodos</span>
      </>
    ),
}];

const PeriodsPage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);

    const columns = [
        {
          title: 'Tipo',
          dataIndex: 'tipo',
          key: 'tipo',
        },
        {
          title: 'Descripcion',
          dataIndex: 'descripcion',
          key: 'descripcion',
        },
        {
          title: 'Clave SAT',
          dataIndex: 'clave_sat',
          key: 'clave_sat',
        },
        {
          title: '',
          dataIndex: 'actions',
          key: 'actions',
          render: (item, object)=> {
            return <Space>
            <Button type='primary' size='small' onClick={()=>{
                openDetails(object);
            }}>Editar</Button>
            <Button type='primary' size='small' danger onClick={()=>{
                deleteConfirm(object);
            }}>Eliminar</Button>
          </Space>
          }
        }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setPeriodSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el periodo?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El periodo ha sido eliminadó!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setPeriodSelected(null);
    }

    const onHandlerFinish = async (refresh, avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }
      
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes}
        title={'Periodos'} 
        cardTitle='Lista de periodos'
        extraCard={[
          <Button type="primary" onClick={btnClick}>
            Agregar Periodo
        </Button>
      ]}
      >
      {
          items.length == 0 ? <Empty />:
          <Table dataSource={items} columns={columns} />
      }
      {
        (openEdit && periodSelected && periodSelected.id > 0) &&
        <ModalEdit title={"Editar Periodo"} id={periodSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !periodSelected) &&
        <ModalEdit title={"Crear Periodo"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default PeriodsPage;
